import React from 'react'
import Navbar from '../../components/Public/Navbar'
import Footer from '../../components/Public/Footer'
import Main from './Home/Main'

export default function Home() {
  return (
    <>
      <Navbar />
      <Main />
      <Footer />
    </>
  )
}
